<div id="exo-information" class="row information-container test-main">
  <ng-container *ngIf="exercice">
    <form [formGroup]="exerciceFormGroup">
      <div class="row">
        <div class="left">
          <h2 class="center grey darken-1 white-text title-information">Exercice</h2>
        </div>
      </div>

      <div class="row information-subcontainer">

        <!-- Titre -->
        <div class="col l12">
          <span class="flexchild nogrow">Titre :</span>
          <span class="flexchild title-input">
            <ng-container *ngIf="!isEditMode">{{ exercice.title }}</ng-container>
            <ng-container *ngIf="isEditMode">
              <input class="w-full" type="text" formControlName="title" />
            </ng-container>
          </span>
        </div>

        <!-- Difficulté -->
        <div class="col l12 flexparent centeralign">
          <span class="flexchild nogrow">Difficulté :</span>
          <ng-container *ngIf="!isEditMode">
            <span class="flexchild">{{ exercice.difficulty }}</span>
          </ng-container>
          <ng-container *ngIf="isEditMode">
            <mat-radio-group class="flexchild" formControlName="difficulty">
              <mat-radio-button *ngFor="let d of difficultyList" [value]="d.data">{{ d.label }}</mat-radio-button>
            </mat-radio-group>
          </ng-container>
        </div>

        <!-- Durée (readonly toujours) -->
        <div class="col l12">
          <span class="flexchild nogrow">Durée :</span>
          <span class="flexchild">{{ exercice.duration }} min</span>
        </div>

        <!-- Instructions -->
        <div class="col l12">
          <span class="flexchild nogrow">Instructions :</span>
          <div class="flexchild instructions-input">
            <ng-container *ngIf="!isEditMode">
              {{ exercice.instruction_student }}
            </ng-container>
            <ng-container *ngIf="isEditMode">
              <textarea class="w-full" formControlName="instructions" rows="5"></textarea>
            </ng-container>
          </div>
        </div>

        <!-- Catégorie -->
        <div class="col l12">
          <span class="flexchild nogrow">Catégorie :</span>
          <ng-container *ngIf="!isEditMode">
            <span class="flexchild">{{ exercice.category }}</span>
          </ng-container>
          <ng-container *ngIf="isEditMode">
            <mat-radio-group formControlName="category" class="flexchild">
              <mat-radio-button *ngFor="let c of categoryList" [value]="c.url">
                {{ c.name }}
              </mat-radio-button>
            </mat-radio-group>
          </ng-container>
        </div>

        <!-- Pièce jointe -->
        <div class="col l12">
          <span class="flexchild nogrow">Pièce jointe :</span>
          <span class="flexchild">
            <ng-container>
              <a mat-button class="default-btn" color="primary" (click)="downloadFile()">Download</a>
            </ng-container>
            <ng-container *ngIf="isEditMode">
              <input type="file" (change)="onFileSelected($event)" />
              <span *ngIf="selectedFileName">{{ selectedFileName }}</span>
            </ng-container>
          </span>
        </div>

        <!-- Bouton PATCH -->
        <div class="col l12 center" *ngIf="isEditMode">
          <button mat-raised-button color="primary" (click)="patchExercice()" [disabled]="exerciceFormGroup.invalid">
            Patch
          </button>
        </div>
      </div>
    </form>
  </ng-container>
</div>